/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { CacheType, IActionContext, IActionInput } from '@msdyn365-commerce/core';

import { IModuleStates } from './module-state.data';

/**
 * GetModulesInput.
 */
export class ModuleStatesCacheKey implements IActionInput {
    public getCacheKey = () => 'ModuleState';

    public getCacheObjectType = () => 'ModuleState';

    public dataCacheType = (): CacheType => 'none';
}

export function getModuleStates(ctx: IActionContext): IModuleStates {
    const cacheKey = new ModuleStatesCacheKey();

    let moduleStates = <IModuleStates>ctx.get<IModuleStates>(cacheKey.getCacheObjectType(), cacheKey.getCacheKey());
    if (moduleStates) {
        return moduleStates;
    }
    ctx.update(cacheKey, {});
    moduleStates = <IModuleStates>ctx.get<IModuleStates>(cacheKey.getCacheObjectType(), cacheKey.getCacheKey());
    return moduleStates;
}

export function updateModuleStates(value: IModuleStates, ctx: IActionContext): void {
    const cacheKey = new ModuleStatesCacheKey();
    ctx.update(cacheKey, value);
}
